import React from 'react';
import { Redirect, Route} from 'react-router-dom';
import useSubscribers from '../../hooks/useSubscribers';
import { PAGE_PATHS } from '../../constant';
// import useAuth from '../../hooks/useAuth';


interface PrivateRouteProps {
  redirectTo?: string;
  path: string;
  exact?: boolean;
  children: React.ReactNode;
}

export default function PrivateRoute({path, exact, children} : PrivateRouteProps) {
  const { subscribersInfo } = useSubscribers()
  return (
    <Route

      path = { path }
      exact = { exact }
      render={({ location }) =>(
        
        subscribersInfo.errorData?.response?.data.Code!=="Errors.Authorization.NoToken"?
          children
        : (
          <Redirect
            to={{
              pathname: PAGE_PATHS.SUBSCRIBERS_LOGIN+'/'+location.pathname.split('/')[3],
              state: { from: location }
            }}
          />
        )
      )
      }
    />
  );
}